module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "back",
    staticStyle: {
      "margin-left": "0"
    },
    on: {
      "click": _vm.redirect
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45275049","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/Back.html
// module id = 561
// module chunks = 1